import axios from "axios";

import React, { useEffect } from "react";
import { useAuth } from "../Context/authContext";

function useApi() {
  const {logout} = useAuth()
  useEffect(() => {
    const endpoint = process.env.REACT_APP_SERVER_URL;
    axios.interceptors.request.use((config) => {
      config.baseURL = endpoint;
      config.headers.Authorization = "Bearer " + localStorage.getItem("token");   
      return config;
    });
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const status = error?.response?.status;
        const {message=""} = error?.response?.data || {};
        if (status === 401 && message.toLowerCase().includes("unauthorized")) {
          logout()
        }

        return Promise.reject(error);
      }
    );
  }, []);
}

export default useApi;
